import {useFirmProfileQuery} from '@/features/firm-settings';
import {useUserDetails} from '@/lib/auth';

export interface CurrentFirmIdentity {
  logoUrl: string | undefined;
  name: string;
}

/** Single source of truth for the current firm's display identity — prefer this over reading `org` off `useUserDetails` directly, same rationale as `useCurrentUserIdentity`. */
export function useCurrentFirmIdentity(): CurrentFirmIdentity {
  const {org} = useUserDetails();
  const {data: profile} = useFirmProfileQuery();

  if (profile) {
    return {
      logoUrl: profile.logoUrl ?? undefined,
      name: profile.displayName
    };
  }

  return {
    logoUrl: org?.logoUrl ?? undefined,
    name: org?.displayName ?? org?.name ?? ''
  };
}
